import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const DevelopmentProject: FC = () => {
  return <Outlet />;
};

export default DevelopmentProject;
